import _ from "lodash";
const mime = require('mime');

// https://github.com/validatorjs/validator.js
import validator from 'validator';

// https://github.com/mattickx/jsvat-next
import { checkVAT, countries } from 'jsvat-next';

export default {
	data() {
		return {
			mixin_rules: {
				required: v => v !== null && v?.toString().trim() !== "" || "Campo obbligatorio",
				radioRequired: v => !!v || "Seleziona un'opzione",
				fileRequired: v => !!v || 'File obbligatorio',
				selectRequired: v => !!v || 'Campo obbligatorio',
				requiredObject: v => Boolean(Object.keys(v || {})[0]) || "Campo obbligatorio",
				// email: v => !v || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || "Email non valida",
				email: v => !v || validator.isEmail(v) || "Email non valida",
				min0: days => days >= 0 || 'Valore minimo: 0',
				min1: days => days >= 1 || 'Valore minimo: 1',
				max_7_interi_2_decimali_e_virgola: v => !v
					|| /^[0-9]{1,7}(,[0-9]{1,2})?$/.test(v)
					|| 'Max 7 interi e 2 decimali separati da virgola (non il punto)',
				max_7_interi_separati_da_punto_2_decimali_e_virgola_per_i_decimali: v => !v
					|| /^(?:(?:\d{1,7})|(?:\d{1,3}\.\d{3})|(?:\d\.\d{3}\.\d{3}))(?:,\d{1,2})?$/.test(v)
					|| 'Max 7 interi (accettato e opzionale il separatore delle migliaia) e 2 decimali separati da virgola',
				// isNumber: v => !isNaN(v) || "Non è un numero",
				// codiceUnivocoContrattoDiServizio: v => v === null || /^[A-Z0-9]{7}$/.test(v) || "Codice Univoco non valido",
				numero_di_emergenza: v => !v
					|| /^[0-9+\-/\s]+$/.test(v)
					|| "Numero di emergenza non valido, sono consentiti solo i seguenti caratteri: cifre da 0 a 9, +, -, / e spazi vuoti",
				telefono: v => !v
					|| /^[0-9+\-/\s]+$/.test(v)
					|| "Numero di telefono non valido, sono consentiti solo i seguenti caratteri: cifre da 0 a 9, +, -, / e spazi vuoti",
				partita_iva: v => !v
					|| checkVAT(v, countries).isValid
					|| 'Partita IVA non valida',
				codice_identificativo:  v => !v
					|| /^[+-][A-Za-z0-9]{64}$/.test(v)
					|| "Codice identificativo non valido, assicurati che inizi con il carattere + o - e che sia seguito da 64 caratteri alfanumerici",
				codice_sdi: v => !v || v.length == 7 || 'Il Codice SDI deve essere lungo 7 caratteri'
			},

			generalSuccessMessage: 'Azione eseguita con successo',

			isGettingFile: {
				brochure_personalizzata: false,
				accordo_prenotazione: false,
				modulo_codice_clickday: false,
				modulo_riepilogo: false,
				modulo_domanda: false,
				contratto_di_servizio: false,
				screenshot_registrazione: false,
				screenshot_invio: false,
				ricevuta_click_day: false,
				esito_rna: false,
				fattura_acconto: false,
				fattura_saldo: false,
				fattura_acconto_esiti_definitivi: false,
				fattura_saldo_esiti_definitivi: false,
				report: false,
			},

			clienteVoid: {
				id: null,
				utente_id: null,
				codice_cliente: null,
				nome: null,
				cognome: null,
				email: null,
				ragione_sociale: null,
				tipologia: null,
				telefono: null,
				brochure_personalizzata: null, // file upload
				path_brochure_personalizzata: null,
				guida_conclusa: false,
				created_at: null,
				updated_at: null,
				numero_pratiche: null, // relationships count
			},

			accordoVoid: {
				id: null,
				cliente_id: null,
				account_manager_id: null,
				account_manager: {}, // relationship
				bando_id: null,
				custom_id: null,
				link_affare: null,
				path_accordo_prenotazione: null,
				is_gold: false,
				tipo_di_fatturazione: null,
				notes: null,
				nome_referente: null,
				cognome_referente: null,
				email_referente: null
			},

			praticaVoid: {
				id: null,
				accordo: {
					id: null,
					custom_id: null
				},
				accordo_id: null,
				cliccatore_id: null,
				old_cliccatore_id: null,
				contratto_di_servizio_id: null,
				cliccatore: {
					id: null,
					username: null,
					codice_cliccatore: null,
					bandi_simulatore: [
						{
							esito_bando: {
								tempo_clickday: null,
								esito_clickday: null
							},
						}
					]
				}, // quando c'è la relazione questo campo è un oggetto
				custom_id: null,
				agevolazione_richiesta: null,
				// denominazione: null,
				ragione_sociale: null,
				partita_iva_codice_fiscale: null,
				codice_identificativo: null,
				codice_ditta: null,
				regione: null,
				provincia: null,
				asse_di_finanziamento_id: null,
				numero_di_emergenza: null,
				pec: null,
				is_pec_abilitata: null,
				priorita: null,
				path_modulo_codice_clickday: null,
				path_attestazione_predisposizione_domanda: null,
				path_modulo_domanda: null,
				codice_identificativo_soggetto_proponente: null,
				codice_identificativo_domanda: null,
				codice_accesso_procedura_invio: null,
				codice_predisposizione_domanda: null,
				path_screenshot_registrazione: null,
				path_screenshot_invio: null,
				path_ricevuta_click_day: null,
				path_esito_rna: null,
				path_modulo_riepilogo: null,
				contratto_di_servizio: { // relationship
					id: null,
					path_contratto_di_servizio: null,
					nome: null,
					cognome: null,
					email: null,
					telefono: null,
					ragione_sociale: null,
					partita_iva: null,
					codice_fiscale: null,
					indirizzo_fatturazione: null,
					cap_fatturazione: null,
					comune_fatturazione: null,
					provincia_fatturazione: null,
					sigla_provincia_fatturazione: null,
					nazione_fatturazione: null,
					// data_di_nascita: null,
					// luogo_di_nascita: null,
					pec: null,
					codice_univoco: null,
					data_scadenza_acconto: null,
					data_scadenza_saldo: null,
					importo_acconto: null,
					importo_saldo: null,
					path_fattura_acconto: null,
					path_fattura_saldo: null,
					data_scadenza_acconto_esiti_definitivi: null,
					data_scadenza_saldo_esiti_definitivi: null,
					importo_acconto_esiti_definitivi: null,
					importo_saldo_esiti_definitivi: null,
					path_fattura_acconto_esiti_definitivi: null,
					path_fattura_saldo_esiti_definitivi: null,
					tipo: null,
					tipo_contratto_di_servizio_id: null,
					tipo_contratto_di_servizio: {
						id: null,
						bando_id: null,
						nome: null,
						is_gold: false,
						is_partner: false,
						tipo_pagamento: null,
						// il resto non è visibile sul front-end, mi serve solo nel back-end per fare i calcoli
					},
					tipo_erogazione_bonus: null,
					importo_totale_bonus_esiti_provvisori: null,
					importo_totale_bonus_esiti_definitivi: null,
					is_gold: false,
					numero_domande: null,
					notes: null,
					punteggio_di_rischio: null,
					score_internazionale: null,
					path_report: null
				},
				descrizione_screenshot_invio: null,
				data_ora_screenshot_invio: null,
				data_ora_screenshot_registrazione: null,
				data_ora_ricevuta: null,
				link_elenco_cronologico: null,
				codice_univoco_di_preconvalida: null,
				nome_utente: null,
				password: null,
				rientra_tra_i_territori_alluvionati: null,
				notes: null,
				importo_da_fatturare: null,
				importo_da_fatturare_esiti_definitivi: null,
				importo_bonus_esiti_provvisori: null,
				importo_bonus_esiti_definitivi: null,
				anteprima_importo_da_fatturare: null,
				id_stato_fase_1: 1,
				id_stato_fase_2: 3,
				id_stato_fase_3: 5,
				id_stato_fase_4: 7,
				id_stato_fase_5: 9,
				id_stato_fase_6: 12,
				id_stato_fase_7: 14,
				id_stato_fase_8: 16,
				id_stato_fase_9: 18,
				ci_sono_aggiornamenti_fase_1: false,
				ci_sono_aggiornamenti_fase_2: false,
				ci_sono_aggiornamenti_fase_3: false,
				ci_sono_aggiornamenti_fase_4: false,
				ci_sono_aggiornamenti_fase_5: false,
				ci_sono_aggiornamenti_fase_6: false,
				ci_sono_aggiornamenti_fase_7: false,
				ci_sono_aggiornamenti_fase_8: false,
				ci_sono_aggiornamenti_fase_9: false,
				ci_sono_aggiornamenti_per_account_manager_fase_1: false,
				modifiche_in_coda: null,
				modifiche_messe_in_coda_da_account_manager_id: null,
				ultima_modifica: null,
				esito_clickday_manuale: null
			},

			accountManagerVoid: {
				id: null,
				utente_id: null,
				nome: null,
				cognome: null,
				cellulare: null,
				email: null,
				link_whatsapp: null,
				impostazioni: null,
				gruppo: null,
				cambio_stato_fasi_in_massa_abilitato: false,
				created_at: null,
				updated_at: null
			},

			faseVoid: {
				id: null,
				bando_id: null,
				ordinamento: null,
				nome: null,
				descrizione: null,
				created_at: null,
				updated_at: null
			},

			statoVoid: {
				id: null,
				fase_id: null,
				ordinamento: null,
				nome: null,
				descrizione: null,
				codice_colore: null,
				created_at: null,
				updated_at: null
			},

			tipologieCliente: [
				'Consulente',
				'Azienda',
				'Associazione di categoria'
			],

			regioniItems: [
				'Abruzzo',
				'Basilicata',
				'Bolzano',
				'Calabria',
				'Campania',
				'Emilia-Romagna',
				'Friuli-Venezia Giulia',
				'Lazio',
				'Liguria',
				'Lombardia',
				'Marche',
				'Molise',
				'Piemonte',
				'Puglia',
				'Sardegna',
				'Sicilia',
				'Toscana',
				'Trento',
				'Umbria',
				"Valle d'Aosta",
				'Veneto'
			],

			tipiContrattoDiServizioOld: [
				'azienda g1',
				'azienda g2',
				'azienda g3',
				'azienda g4',
				'azienda g5',
				'partner'
			],

			tipiEsitoClickday: [
				'Iscritto',
				'In attesa di esito',
				'Vincente Esiti Provvisori',
				'Non vincente',
				'Abbandonato / Screenshot mancante',
				'Non assegnato',
				'Vincente Esiti Definitivi'
			],

			strutturaDatiPraticaBando23: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo Codice Click Day',
								key: 'path_modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'path_modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'La tua casella PEC è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Modulo Codice Click Day',
								key: 'modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Importo Agevolazione Richiesta',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true
							},
							// {
							// 	label: 'Denominazione',
							// 	key: 'denominazione',
							// 	ref: 'pratica',
							// 	send_email: true // se true viene incluso nella lista delle modifiche inviate per email (se nelle modifiche apportate alla pratica non ci sono dati con send_email: true non devo mostrare la checkbox per inviare l'email
							// },
							{
								label: 'Codice Identificativo',
								key: 'codice_identificativo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice Ditta',
								key: 'codice_ditta',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Regione',
								key: 'regione',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Asse di Finanziamento',
								key: 'asse_di_finanziamento_id',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'La PEC primaria associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Priorità',
								key: 'priorita',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Data di Nascita',
							// 	key: 'data_di_nascita',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Luogo di Nascita',
							// 	key: 'luogo_di_nascita',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo',
								key: 'tipo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Gold',
								key: 'is_gold',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Numero Domande',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
					},
					3: {
						nome: 'PUBBLICAZIONE REGOLE TECNICHE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'ALLENAMENTO DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					6: {
						nome: 'REGISTRAZIONE AL PORTALE PARTECIPANTE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'path_screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					7: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 7',
								key: 'id_stato_fase_7',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					8: {
						nome: 'PUBBLICAZIONE ELENCHI CRONOLOGICI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 8',
								key: 'id_stato_fase_8',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Provvisori',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Definitivi',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							}
						]
					},
					9: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 9',
								key: 'id_stato_fase_9',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Data di Nascita',
							// 	key: 'data_di_nascita',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Luogo di Nascita',
							// 	key: 'luogo_di_nascita',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza dell\'Acconto Esiti Provvisori',
								key: 'data_scadenza_acconto',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza del Saldo Esiti Provvisori',
								key: 'data_scadenza_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile dell\'Acconto Esiti Provvisori',
								key: 'importo_acconto',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile del Saldo Esiti Provvisori',
								key: 'importo_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Acconto Esiti Provvisori',
								key: 'path_fattura_acconto',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'path_fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza dell\'Acconto Esiti Definitivi',
								key: 'data_scadenza_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza del Saldo Esiti Definitivi',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile dell\'Acconto Esiti Definitivi',
								key: 'importo_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile del Saldo Esiti Definitivi',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Acconto Esiti Definitivi',
								key: 'path_fattura_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						],
						files: [
							{
								label: 'Fattura Acconto Esiti Provvisori',
								key: 'fattura_acconto',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Acconto Esiti Definitivi',
								key: 'fattura_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando25: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Attestazione di avvenuta Predisposizione della Domanda',
								key: 'path_attestazione_predisposizione_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Domanda',
								key: 'path_modulo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							}
						],
						files: [
							{
								label: 'Attestazione di avvenuta Predisposizione della Domanda',
								key: 'attestazione_predisposizione_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Domanda',
								key: 'modulo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice identificativo soggetto proponente',
								key: 'codice_identificativo_soggetto_proponente',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice identificativo domanda',
								key: 'codice_identificativo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice di accesso alla procedura di invio',
								key: 'codice_accesso_procedura_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice di predisposizione domanda',
								key: 'codice_predisposizione_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Numero Domande',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Gold',
								key: 'is_gold',
								ref: 'contratto_di_servizio',
								send_email: false
							},
						],
					},
					3: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ricevuta del Click',
								key: 'path_ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ricevuta del Click',
								key: 'ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'PUBBLICAZIONE ELENCHI CRONOLOGICI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							}
						]
					},
					6: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: "Data di Scadenza dell'Acconto",
								key: 'data_scadenza_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza del Saldo',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: "Imponibile dell'Acconto",
								key: 'importo_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile del Saldo',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Acconto',
								key: 'path_fattura_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						],
						files: [
							{
								label: 'Fattura Acconto',
								key: 'fattura_acconto_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando33: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice di predisposizione domanda',
								key: 'codice_predisposizione_domanda',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modulo di Domanda',
								key: 'path_modulo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
						],
						files: [
							{
								label: 'Modulo di Domanda',
								key: 'modulo_domanda',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice di predisposizione domanda',
								key: 'codice_predisposizione_domanda',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Punteggio di Rischio',
								key: 'punteggio_di_rischio',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Score Internazionale',
								key: 'score_internazionale',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Report',
								key: 'path_report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Anteprima Imponibile da Fatturare in Caso di Vittoria',
								key: 'anteprima_importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							}
						],
						files: [
							{
								label: 'Report',
								key: 'report',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
						]
					},
					3: {
						nome: 'ASSEGNAZIONE E DELEGA DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ricevuta del Click',
								key: 'path_ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ricevuta del Click',
								key: 'ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'PUBBLICAZIONE PROVVEDIMENTI DI CONCESSIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Provvisori',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Definitivi',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile Bonus Esiti Provvisori',
								key: 'importo_bonus_esiti_provvisori',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Imponibile Bonus Esiti Definitivi',
								key: 'importo_bonus_esiti_definitivi',
								ref: 'pratica',
								send_email: false
							}
						]
					},
					6: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Tipo',
							// 	key: 'tipo',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Provvisori',
								key: 'data_scadenza_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Provvisori',
								key: 'importo_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Provvisori',
								key: 'path_fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Definitivi',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Definitivi',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Definitivi',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
						files: [
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando26: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo Codice Click Day',
								key: 'path_modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'path_modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'La tua casella PEC è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Modulo Codice Click Day',
								key: 'modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice Identificativo',
								key: 'codice_identificativo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice Ditta',
								key: 'codice_ditta',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Regione',
								key: 'regione',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Asse di Finanziamento',
								key: 'asse_di_finanziamento_id',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'La PEC primaria associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Priorità',
								key: 'priorita',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo',
								key: 'tipo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Punteggio di Rischio',
								key: 'punteggio_di_rischio',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Score Internazionale',
								key: 'score_internazionale',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Report',
								key: 'path_report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
						],
						files: [
							{
								label: 'Report',
								key: 'report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
						]
					},
					3: {
						nome: 'PUBBLICAZIONE REGOLE TECNICHE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'ALLENAMENTO DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					6: {
						nome: 'REGISTRAZIONE AL PORTALE PARTECIPANTE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'path_screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					7: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 7',
								key: 'id_stato_fase_7',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					8: {
						nome: 'PUBBLICAZIONE ELENCHI CRONOLOGICI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 8',
								key: 'id_stato_fase_8',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Provvisori',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Definitivi',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile Bonus Esiti Provvisori',
								key: 'importo_bonus_esiti_provvisori',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Imponibile Bonus Esiti Definitivi',
								key: 'importo_bonus_esiti_definitivi',
								ref: 'pratica',
								send_email: false
							}
						]
					},
					9: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 9',
								key: 'id_stato_fase_9',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Tipo',
							// 	key: 'tipo',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza Fattura Esiti Provvisori',
								key: 'data_scadenza_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Provvisori',
								key: 'importo_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Provvisori',
								key: 'path_fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza Fattura Esiti Definitivi',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Definitivi',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Definitivi',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
						files: [
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando28: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Domanda',
								key: 'path_modulo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice Univoco di Preconvalida',
								key: 'codice_univoco_di_preconvalida',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome Utente',
								key: 'nome_utente',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Password',
								key: 'password',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'PEC Validata',
								key: 'pec',
								ref: 'pratica',
								send_email: true
							}
						],
						files: [
							{
								label: 'Modulo di Domanda',
								key: 'modulo_domanda',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Codice Univoco di Preconvalida',
								key: 'codice_univoco_di_preconvalida',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome Utente',
								key: 'nome_utente',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Password',
								key: 'password',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'PEC Validata',
								key: 'pec',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Sede Operativa',
								key: 'provincia',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Rientra tra i territori alluvionati?',
								key: 'rientra_tra_i_territori_alluvionati',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Priorità',
								key: 'priorita',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo',
								key: 'tipo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Punteggio di Rischio',
								key: 'punteggio_di_rischio',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Score Internazionale',
								key: 'score_internazionale',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Report',
								key: 'path_report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
						],
						files: [
							{
								label: 'Report',
								key: 'report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
						]
					},
					3: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'ESITO CLICK DAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile Bonus',
								key: 'importo_bonus_esiti_definitivi',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'PEC Esito',
								key: 'path_ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Esito RNA',
								key: 'path_esito_rna',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Esito Manuale Pratica',
								key: 'esito_clickday_manuale',
								ref: 'pratica',
								send_email: false
							},
						],
						files:[
							{
								label: 'PEC Esito',
								key: 'ricevuta_click_day',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Esito RNA',
								key: 'esito_rna',
								ref: 'pratica',
								send_email: false
							},
						]
					},
					6: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Data di Scadenza Fattura',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
						files: [
							{
								label: 'Fattura',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando29: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo Codice Click Day',
								key: 'path_modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'path_modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: "PEC primaria dell'azienda associata alla domanda",
								key: 'pec',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'La tua casella PEC è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
						],
						files: [
							{
								label: 'Modulo Codice Click Day',
								key: 'modulo_codice_clickday',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'modulo_riepilogo',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Identificativo',
								key: 'codice_identificativo',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Ditta',
								key: 'codice_ditta',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Regione',
								key: 'regione',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Asse di Finanziamento',
								key: 'asse_di_finanziamento_id',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: "PEC primaria dell'azienda associata alla domanda",
								key: 'pec',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'La PEC primaria associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Priorità',
								key: 'priorita',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Punteggio di Rischio',
								key: 'punteggio_di_rischio',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Score Internazionale',
								key: 'score_internazionale',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Report',
								key: 'path_report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Anteprima Imponibile da Fatturare in Caso di Vittoria',
								key: 'anteprima_importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							}
						],
						files: [
							{
								label: 'Report',
								key: 'report',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
						]
					},
					3: {
						nome: 'PUBBLICAZIONE REGOLE TECNICHE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'ALLENAMENTO DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					6: {
						nome: 'REGISTRAZIONE AL PORTALE PARTECIPANTE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'path_screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					7: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 7',
								key: 'id_stato_fase_7',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					8: {
						nome: 'PUBBLICAZIONE ELENCHI CRONOLOGICI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 8',
								key: 'id_stato_fase_8',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Provvisori',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Definitivi',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile Bonus Esiti Provvisori',
								key: 'importo_bonus_esiti_provvisori',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Imponibile Bonus Esiti Definitivi',
								key: 'importo_bonus_esiti_definitivi',
								ref: 'pratica',
								send_email: false
							}
						]
					},
					9: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 9',
								key: 'id_stato_fase_9',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Tipo',
							// 	key: 'tipo',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Provvisori',
								key: 'data_scadenza_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Provvisori',
								key: 'importo_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Provvisori',
								key: 'path_fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Definitivi',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Definitivi',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Definitivi',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
						files: [
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			strutturaDatiPraticaBando31: {
				fasi: {
					1: {
						nome: 'CARICA I DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 1',
								key: 'id_stato_fase_1',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo Codice Click Day',
								key: 'path_modulo_codice_clickday',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'path_modulo_riepilogo',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'path_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Scegli un Contratto di servizio già associato ad una pratica',
								key: 'idPraticaConContrattoDiServizio',
								ref: 'pratica',
								send_email: true
							},
							// solo cliente
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: "PEC primaria dell'azienda associata alla domanda",
								key: 'pec',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'La tua casella PEC è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
						],
						files: [
							{
								label: 'Modulo Codice Click Day',
								key: 'modulo_codice_clickday',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modulo di Riepilogo',
								key: 'modulo_riepilogo',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Contratto di Servizio',
								key: 'contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							}
						]
					},
					2: {
						nome: 'RIEPILOGO DEI DATI DELLA PRATICA',
						stati: {}, // li prendo dal db,
						campi: [
							{
								label: 'Stato Fase 2',
								key: 'id_stato_fase_2',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA / Codice Fiscale',
								key: 'partita_iva_codice_fiscale',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Identificativo',
								key: 'codice_identificativo',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Ditta',
								key: 'codice_ditta',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Regione',
								key: 'regione',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Asse di Finanziamento',
								key: 'asse_di_finanziamento_id',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Importo Agevolazione',
								key: 'agevolazione_richiesta',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: "PEC primaria dell'azienda associata alla domanda",
								key: 'pec',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'La PEC primaria associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?',
								key: 'is_pec_abilitata',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Numero di Emergenza',
								key: 'numero_di_emergenza',
								ref: 'pratica',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Priorità',
								key: 'priorita',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Punteggio di Rischio',
								key: 'punteggio_di_rischio',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Score Internazionale',
								key: 'score_internazionale',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
							{
								label: 'Report',
								key: 'path_report',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							{
								label: 'Anteprima Imponibile da Fatturare in Caso di Vittoria',
								key: 'anteprima_importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							}
						],
						files: [
							{
								label: 'Report',
								key: 'report',
								ref: 'contratto_di_servizio',
								send_email: false,
								controllo_campo_non_compilato: true
							},
						]
					},
					3: {
						nome: 'SCADENZE ISI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 3',
								key: 'id_stato_fase_3',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					4: {
						nome: 'ASSEGNAZIONE DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 4',
								key: 'id_stato_fase_4',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					5: {
						nome: 'ALLENAMENTO DEL CLICCATORE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 5',
								key: 'id_stato_fase_5',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					6: {
						nome: 'REGISTRAZIONE AL PORTALE PARTECIPANTE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 6',
								key: 'id_stato_fase_6',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'path_screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot Schermata Registrazione',
								key: 'screenshot_registrazione',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					7: {
						nome: 'CLICKDAY',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 7',
								key: 'id_stato_fase_7',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Screenshot Schermata del Click',
								key: 'path_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Descrizione Screenshot Schermata del Click',
								key: 'descrizione_screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						],
						files: [
							{
								label: 'Screenshot schermata del Click',
								key: 'screenshot_invio',
								ref: 'pratica',
								send_email: true
							},
						]
					},
					8: {
						nome: 'PUBBLICAZIONE ELENCHI CRONOLOGICI',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 8',
								key: 'id_stato_fase_8',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Provvisori',
								key: 'importo_da_fatturare',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile da Fatturare Esiti Definitivi',
								key: 'importo_da_fatturare_esiti_definitivi',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Imponibile Bonus Esiti Provvisori',
								key: 'importo_bonus_esiti_provvisori',
								ref: 'pratica',
								send_email: false
							},
							{
								label: 'Imponibile Bonus Esiti Definitivi',
								key: 'importo_bonus_esiti_definitivi',
								ref: 'pratica',
								send_email: false
							}
						]
					},
					9: {
						nome: 'FATTURAZIONE',
						stati: {},
						campi: [
							{
								label: 'Stato Fase 9',
								key: 'id_stato_fase_9',
								ref: 'pratica',
								send_email: true
							},
							{
								label: 'Nome',
								key: 'nome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Cognome',
								key: 'cognome',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Ragione Sociale',
								key: 'ragione_sociale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Partita IVA',
								key: 'partita_iva',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Fiscale',
								key: 'codice_fiscale',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Indirizzo di Fatturazione',
								key: 'indirizzo_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'CAP di Fatturazione',
								key: 'cap_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Comune di Fatturazione',
								key: 'comune_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Provincia di Fatturazione',
								key: 'provincia_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Nazione di Fatturazione',
								key: 'nazione_fatturazione',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Telefono',
								key: 'telefono',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'PEC',
								key: 'pec',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Codice Univoco SDI',
								key: 'codice_univoco',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Email',
								key: 'email',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							// {
							// 	label: 'Tipo',
							// 	key: 'tipo',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							{
								label: 'Tipo di Contratto di Servizio',
								key: 'tipo_contratto_di_servizio',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Modalità di Erogazione Bonus',
								key: 'tipo_erogazione_bonus',
								ref: 'contratto_di_servizio',
								send_email: false
							},
							// {
							// 	label: 'Modalità di Pagamento',
							// 	key: 'tipo_pagamento',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: true
							// },
							// {
							// 	label: 'Gold',
							// 	key: 'is_gold',
							// 	ref: 'contratto_di_servizio',
							// 	send_email: false
							// },
							{
								label: 'Numero Domande su Contratto',
								key: 'numero_domande',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Provvisori',
								key: 'data_scadenza_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Provvisori',
								key: 'importo_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Provvisori',
								key: 'path_fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Prima Scadenza Fattura Esiti Definitivi',
								key: 'data_scadenza_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Imponibile Fattura Esiti Definitivi',
								key: 'importo_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Esiti Definitivi',
								key: 'path_fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							},
						],
						files: [
							{
								label: 'Fattura Saldo Esiti Provvisori',
								key: 'fattura_saldo',
								ref: 'contratto_di_servizio',
								send_email: true
							},
							{
								label: 'Fattura Saldo Esiti Definitivi',
								key: 'fattura_saldo_esiti_definitivi',
								ref: 'contratto_di_servizio',
								send_email: true
							}
						]
					},
				}
			},

			tourYellow: '#ffff00',

			tipiErogazioneBonus: [
				'Erogazione diretta',
				'Sconto in fattura',
				'Bonus da scontare ai clienti'
			]
		}
	},

	created() {
		// this.validaCodiceFiscalePersonale('pgnfnc90l10d086g').then(valid => {
		// 	console.log(valid)
		// })
	},

	computed: {

	},

	methods: {
		formatDateToItaly(date) {
			if (!date) return null

			const [year, month, day] = date.split('-')
			return `${day}/${month}/${year}`; // 18/02/2019
		},
		formatDateToItalyLong(datetime) {
			if (!datetime) return null
			const options = {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			};
			return new Date(datetime).toLocaleDateString(
				'it-it', options
			); // 18 Febbraio 2019
		},
		formatDateTimeToItalyLong(datetime) {
			if (!datetime) return null
			const options = {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric'
			};
			return new Date(datetime).toLocaleString(
				'it-it', options
			); // 18/02/2019, 18:22:54
		},
		formatDateTimeToItaly(datetime) {
			if (!datetime) return null
			return new Date(datetime).toLocaleString(
				'it-it'
			); // 18/02/2019, 18:22:54
		},
		getDateFromDateTime(datetime) {
			if (!datetime) return null
			return new Date(datetime).toLocaleDateString(
				'it-it'
			); // 18/02/2019
		},
		getFileNameFromPath(path) {
			return path !== null ? path.substring(path.lastIndexOf('/') + 1) : 'Nessun file caricato'
		},

		getFile(path, key) {
			this.isGettingFile[key] = true;
			return axios.post('/api/storage/get-file', { path: path }, { responseType: 'blob' })
				.then(response => {
					return new File([response.data], this.getFileNameFromPath(path), {
						type: mime.getType(path)
					});
				})
				.finally(() => {
					this.isGettingFile[key] = false;
				})
		},
		viewFileInBrowser(file) {
			const fileURL = URL.createObjectURL(file);
			window.open(fileURL);
		},
		async getFileAndViewInBrowser(path, key) {
			const file = await this.getFile(path, key);
			this.viewFileInBrowser(file);
		},
		getFileUrl(path) {
			return axios.post('/api/storage/get-url', { path: path})
				.then(response => {
					return response.data;
				})
		},
		// getBase64File(path) {
		// 	return axios.post('/api/storage/get-base-64-file', { path: path})
		// 		.then(response => {
		// 			return response.data;
		// 		})
		// },

		salvaAggiornamentiVisualizzati(praticaId, dbColumn) {
			axios.post('/api/pratiche/set-aggiornamenti-fase-visualizzati', {
				pratica_id: praticaId,
				db_column: dbColumn
			})
		},

		salvaAggiornamentiDaVisualizzare(praticaId, dbColumn) {
			return axios.post('/api/pratiche/set-aggiornamenti-fase-da-visualizzare', {
				pratica_id: praticaId,
				db_column: dbColumn
			})
		},

		getObjectDiff(obj1, obj2, compareRef= false) {
			return Object.keys(obj1).reduce((result, key) => {
				// se la chiave in obj2 non è presente in obj1 vuol dire che è stato aggiunto un nuovo valore con quella chiave e lo considero come differenza
				if (!obj2.hasOwnProperty(key)) {
					result.push(key);
				} else if (_.isEqual(obj1[key], obj2[key])) {
					const resultKeyIndex = result.indexOf(key);

					if (compareRef && obj1[key] !== obj2[key]) {
						result[resultKeyIndex] = `${key} (ref)`;
					} else {
						result.splice(resultKeyIndex, 1);
					}
				}
				return result;
			}, Object.keys(obj2));
		},
		customFilterByProperties(item, queryText, myProperties) {
			let found = false;
			// Scorro in un elenco di properties inserite da me
			myProperties.forEach(function(myProp){
				if(item[myProp] != null && item[myProp].toLowerCase().indexOf(queryText.toLowerCase()) > -1){
					found = true;
				}
			})

			return found;
		},
		validaPartitaIvaCodiceFiscaleAziendaleItaliano(piva_cf_az) {
			// Questo metodo è stato generato da ChatGPT o1-preview basandosi sull'algoritmo ufficiale
			// Link alla conversazione con ChatGPT: https://chatgpt.com/share/e/6750c227-6488-8009-bb2c-cdf3860ac4e1

			// Rimuove eventuali spazi o caratteri non numerici
			// piva_cf_az = piva_cf_az.replace(/\D/g, '');

			// Verifica che sia composta da 11 cifre
			if (piva_cf_az?.length !== 11) {
				return false;
			}

			let s = 0;
			for (let i = 0; i <= 9; i++) {
				let n = parseInt(piva_cf_az.charAt(i), 10);

				if ((i % 2) === 0) {
					// Posizioni dispari (indice da 0)
					s += n;
				} else {
					// Posizioni pari
					n *= 2;
					if (n > 9) {
						n -= 9;
					}
					s += n;
				}
			}

			let controllo = (10 - (s % 10)) % 10;

			// Confronta il valore calcolato con l'ultima cifra della Partita IVA
			// Se il codice è valido restituisce true altrimenti false
			return controllo === parseInt(piva_cf_az.charAt(10), 10);
		},
		/**
		 * Restituisce il valore di un oggetto seguendo il percorsoDotNotation (scritto in dot-notation),
		 * supporta anche la notazione con array.
		 *
		 * Esempi:
		 * - ottieniValoreDallOggettoUsandoIlPercorso(item, 'cliente.codice_cliente')
		 * - ottieniValoreDallOggettoUsandoIlPercorso(item, 'pratiche[0].accordo.cliente.ragione_sociale')
		 *
		 * Come funziona passo passo:
		 * 1. percorsoDotNotation.replace(/\[/g, '.[') - Trasforma la notazione array in dot-notation
		 *    Esempio: 'pratiche[0].accordo' diventa 'pratiche.[0].accordo'
		 *
		 * 2. .split('.') - Divide la stringa del percorso (scritto in dot-notation) in un array di chiavi
		 *    Esempio: 'pratiche.[0].accordo.cliente' diventa ['pratiche', '[0]', 'accordo', 'cliente']
		 *
		 * 3. .reduce((oggettoCorrente, chiave) => ..., oggetto) - Itera su ogni chiave partendo dall'oggetto iniziale
		 *    - oggettoCorrente: l'oggetto corrente (inizialmente è l'oggetto di partenza, poi scende in profondità)
		 *    - chiave: la chiave corrente da accedere nell'oggetto
		 *
		 * 4. if (chiave.startsWith('[') && chiave.endsWith(']')) - Gestisce gli indici array
		 *    Estrae il numero dall'indice '[0]' e accede all'elemento dell'array
		 *
		 * 5. oggettoCorrente[chiave] !== undefined - Controlla che:
		 *    - oggettoCorrente esista (non sia null o undefined)
		 *    - la proprietà chiave esista nell'oggetto corrente
		 *
		 * 6. ? oggettoCorrente[chiave] : '' - Se il controllo è positivo, restituisce il valore trovato,
		 *    altrimenti restituisce una stringa vuota. Questo permette di evitare errori quando un livello
		 *    della catena non esiste
		 */
		ottieniValoreDallOggettoUsandoIlPercorso (oggetto, percorsoDotNotation) {
			return percorsoDotNotation
				.replace(/\[/g, '.[')  // Trasforma 'pratiche[0]' in 'pratiche.[0]'
				.split('.')
				.reduce((oggettoCorrente, chiave) => {
					if (!oggettoCorrente) return '';

					// Gestisce indici array: '[0]' -> estrae '0'
					if (chiave.startsWith('[') && chiave.endsWith(']')) {
						const indice = parseInt(chiave.slice(1, -1));
						return oggettoCorrente[indice];
					}

					// Gestisce chiavi normali
					return oggettoCorrente[chiave] !== undefined ? oggettoCorrente[chiave] : '';
				}, oggetto);
		},
		// magic link ai dati del cliccatore, usato in fase 3 e nella tabella pratiche
		copiaLinkDatiCliccatore(linkDatiCliccatore) {
			// $copyText crea la textarea temporanea dentro il componente: se fosse nel body, il focus trap del v-dialog impedirebbe la copia
			const copiaNegliAppunti = navigator.clipboard && window.isSecureContext
				? navigator.clipboard.writeText(linkDatiCliccatore)
				: this.$copyText(linkDatiCliccatore, this.$el);

			copiaNegliAppunti
				.then(() => {
					this.$store.dispatch('systemSnackbar/show', { color: 'success', message: 'Link del cliccatore copiato' });
				})
				.catch(() => {
					this.$store.dispatch('systemSnackbar/show', { color: 'error', message: 'Impossibile copiare il link del cliccatore' });
				});
		},
	},
}
